import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../css/Invoice.css";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginAPI } from "../../components/Service/UserService";
import bg from "../../assets/images/bg-login.jpg";
import logo from "../../assets/images/logo-123cloud.svg";
import { Checkbox } from "@mui/material";
import { getProfile } from "../../components/Service/UserService";
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import { motion } from "framer-motion";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [stayLoggedIn, setStayLoggedIn] = useState(false);
    const token = Cookies.get("Token");
    const navigate = useNavigate();
    const [captchaValue, setCaptchaValue] = useState(null);
    const [searchParams] = useSearchParams();
    const [successMessage, setSuccessMessage] = useState("");
    const [Messagekh, setMessagekh] = useState("");
    useEffect(() => {
        setTimeout(() => {
            const activationMessage = Cookies.get('activationMessage');
            if (activationMessage) {
                setErrorMessage(activationMessage);
                Cookies.remove('activationMessage');
            }
        }, 300); // Trì hoãn 300ms để tránh nháy
    }, []);


    const [loadedBg, setLoadedBg] = useState(null);
    const status = searchParams.get("status");

    useEffect(() => {
        setTimeout(() => {
            document.body.style.backgroundImage = `url(${bg})`;
        }); // Delay 300ms để hiệu ứng mượt hơn

        return () => {
            setTimeout(() => {
                document.body.style.backgroundImage = "";
            }); // Khi rời khỏi trang, cũng thêm delay
        };
    }, []);

    const loadUserProfile = async () => {
        try {
            const response = await getProfile();
            localStorage.setItem('Balance1', response?.user?.balance);
            localStorage.setItem('Username', response?.user?.name);
            localStorage.setItem('phone', response?.user?.phone);
            localStorage.setItem('email', response?.user?.email);

            // console.log("Saved Username: ", response?.user?.name);
        } catch (error) {
        }
    };

    useEffect(() => {
        if (token) {
            loadUserProfile(); // Load profile ngay khi có token
            navigate("/dashboard");

        }
    }, [token, navigate]);

    const handleLogin = async () => {
        try {
            if (!email) {
                setErrorMessage("Vui lòng nhập Email!");
                return;
            }
            if (!password) {
                setErrorMessage("Vui lòng nhập Mật khẩu!");
                return;
            }

            if (!captchaValue) {
                setErrorMessage("Vui lòng xác nhận bạn không phải là robot!");
                return;
            }

            Cookies.remove("emailSentSuccess", { path: '/' });

            Cookies.remove("email", { path: '/' });
            Cookies.set("email", email, {
                path: '/',
                secure: true,
                sameSite: 'None',
            });

            const res = await loginAPI(email, password);
            if (res && res.data.token) {
                const tokenExpiry = stayLoggedIn ? 30 : 1;
                const expiryDate = new Date(Date.now() + tokenExpiry * 24 * 60 * 60 * 1000);

                Cookies.set("Token", res.data.token, {
                    expires: expiryDate, path: '/', secure: true,
                    sameSite: 'None',
                });
                Cookies.set("UserName", res.data.name, {
                    expires: expiryDate, path: '/', secure: true,
                    sameSite: 'None'
                });

                toast.success("Đăng nhập thành công!");
                loadUserProfile();

                setTimeout(() => {
                    window.location.href = "/dashboard";
                }, 100);
            } else if (res && res.message === "Kiểm tra email để kích hoạt tài khoản") {
                Cookies.set("emailverify", res.data.email, {
                    expires: 1, path: '/', secure: true, sameSite: 'None'
                });

                setErrorMessage("Kiểm tra email để kích hoạt tài khoản!");
            } else {
                setErrorMessage("Đăng nhập thất bại. Vui lòng thử lại!");
            }


        } catch (error) {

            const errorMessage = error.response?.data?.message || "Đăng nhập thất bại!";
            setErrorMessage(errorMessage);

            if (errorMessage === "Kiểm tra email để kích hoạt tài khoản") {
                setMessagekh("");
                Cookies.remove("emailSentSuccess", { path: '/' });
            }

            toast.error(errorMessage);
        }
    };
    const [loading, setLoading] = useState(false);
    // const handleResentEmail = async () => {
    //     const email = Cookies.get('email');

    //     if (!email) {
    //         toast.error('Không tìm thấy email để gửi lại xác nhận!');
    //         return;
    //     }

    //     setLoading(true);
    //     toast.info('Đang gửi email...');

    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_API_URL}/api/email/verification-notification`,
    //             { email }
    //         );

    //         if (response.data.status === 'success') {
    //             toast.success('Mail xác nhận đã được gửi thành công!');
    //         }
    //     } catch (error) {
    //         const errorMessage = error.response?.data?.message || 'Có lỗi xảy ra';
    //         toast.error(errorMessage);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const handleResentEmail = async () => {
        const email = Cookies.get('email'); // Lấy email từ cookies

        if (!email) {
            toast.error('Không tìm thấy email để gửi lại xác nhận!');
            return;
        }

        setLoading(true);
        toast.info('Đang gửi email...');

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/email/verification-notification`,
                { email }
            );

            if (response.data.status === 'success') {
                // Cập nhật trạng thái đã gửi thành công
                setMessagekh("Đã gửi email thành công.");
                Cookies.set('emailSentSuccess', 'true', { path: '/' });

                setTimeout(() => {
                    setMessagekh("Kiểm tra email để kích hoạt tài khoản.");
                    Cookies.remove("emailSentSuccess", { path: '/' });
                }, 5000); // Reset về trạng thái kiểm tra email sau 5 giây
            } else {
                toast.error('Không thể gửi email. Vui lòng thử lại sau!');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Có lỗi xảy ra';
            toast.error(errorMessage);
        } finally {
            setLoading(false); // Kết thúc trạng thái loading
        }
    };




    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <div
                className="container"

            >

                <div className="row justify-content-center">
                    <div className="col-12">
                        <section className="ftco-section login">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-5 col-lg-5">
                                        <div className="box-login">

                                            <form>
                                                <div className="login-right">
                                                    {/* Logo */}
                                                    <div className="logo-main text-center">
                                                        <img
                                                            style={{
                                                                backgroundColor: "white",
                                                                padding: "8px",
                                                                marginTop: "-5px",
                                                                width: "30%",
                                                            }}
                                                            className="navbar-brand-full logo-header"
                                                            src={`${process.env.REACT_APP_IMAGE_LOGO}/images/logo.svg`}
                                                            alt="TIDADIGI"
                                                        />
                                                    </div>

                                                    {/* Tiêu đề */}
                                                    <h1 className="login-title text-center">Đăng nhập</h1>
                                                    {(Messagekh || errorMessage === "Kiểm tra email để kích hoạt tài khoản") && (
                                                        <div
                                                            className={`alert ${Messagekh ? 'alert-success' : 'alert-danger'}`}
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            {Messagekh || errorMessage}
                                                            {!Messagekh && errorMessage === "Kiểm tra email để kích hoạt tài khoản" && (
                                                                <span style={{ textAlign: 'center' }}>
                                                                    <a
                                                                        href="#"
                                                                        style={{
                                                                            color: 'red',
                                                                            fontWeight: 'bold',
                                                                            cursor: 'pointer',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center'
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleResentEmail(); // Gọi lại hàm gửi email
                                                                        }}
                                                                    >
                                                                        {loading ? (
                                                                            <span style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                <span
                                                                                    style={{
                                                                                        width: '16px',
                                                                                        height: '16px',
                                                                                        marginLeft: '8px',
                                                                                        marginRight: '8px',
                                                                                        border: '2px solid red',
                                                                                        borderTop: '2px solid transparent',
                                                                                        borderRadius: '50%',
                                                                                        animation: 'spin 1s linear infinite',
                                                                                    }}
                                                                                ></span>
                                                                                Đang gửi...
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ marginLeft: "10px" }}>Gửi lại email</span>
                                                                        )}
                                                                    </a>
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}

                                                    {errorMessage && errorMessage !== "Kiểm tra email để kích hoạt tài khoản" && (
                                                        <div
                                                            className="alert alert-danger"
                                                            role="alert"
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            {errorMessage}
                                                        </div>
                                                    )}

                                                    {/* {errorMessage && errorMessage !== "Kiểm tra email để kích hoạt tài khoản" && (
                                                    <div
                                                        className="alert alert-danger"
                                                        role="alert"
                                                        style={{ fontSize: "14px" }}
                                                    >
                                                        {errorMessage}
                                                    </div>
                                                )} */}


                                                    {status && (
                                                        <div
                                                            className="alert alert-success"
                                                            role="alert"
                                                            style={{ fontSize: "14px" }}
                                                        >
                                                            {status === 'success' && <span>Email verified successfully. You can now log in.</span>}
                                                            {status === 'already_verified' && <span>Your email is already verified. Please log in.</span>}
                                                            {status === 'error' && <span>There was an error verifying your email. Please try again.</span>}
                                                        </div>
                                                    )}

                                                    <div className="form-group mb-3">
                                                        <label className="label-login" htmlFor="email">
                                                            Email
                                                        </label>
                                                        <input
                                                            id="email"
                                                            type="email"
                                                            className="form-control-login"
                                                            placeholder="Email"
                                                            name="email"
                                                            required
                                                            autoComplete="email"
                                                            autoFocus
                                                            onChange={(event) => setEmail(event.target.value.trim())}
                                                        />
                                                    </div>

                                                    <div className="form-group mb-3">
                                                        <label className="label-login" htmlFor="password">
                                                            Mật khẩu
                                                        </label>
                                                        <input
                                                            id="password"
                                                            type="password"
                                                            className="form-control-login"
                                                            placeholder="****************"
                                                            name="password"
                                                            required
                                                            autoComplete="current-password"
                                                            onChange={(event) => setPassword(event.target.value)}
                                                        />
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            margin: "10px 0"
                                                        }}
                                                        className="form-group mb-3"
                                                    >
                                                        <ReCAPTCHA
                                                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                                            onChange={(value) => setCaptchaValue(value)}
                                                        />
                                                    </div>



                                                    <div className="mb-3">
                                                        <Checkbox
                                                            id="check"
                                                            type="checkbox"
                                                            name="stayLoggedIn"
                                                            checked={stayLoggedIn}
                                                            onChange={(event) => setStayLoggedIn(event.target.checked)}
                                                            color="primary"
                                                            style={{ position: "relative", top: "-2px" }}
                                                        />

                                                        <span style={{ color: "#333", fontSize: "14px" }}>Duy trì đăng nhập</span>
                                                    </div>

                                                    <div className="form-group">
                                                        <button
                                                            type="button"
                                                            style={{ background: "#040053", color: "white" }}
                                                            className="form-control-btn btn  submit px-3"
                                                            onClick={handleLogin}
                                                        >
                                                            Đăng nhập
                                                        </button>
                                                    </div>

                                                    <div className="login-bottom text-center mt-3">
                                                        <span style={{ color: "gray", fontSize: "16px" }}>
                                                            Chưa có tài khoản?{" "}
                                                            <a
                                                                style={{
                                                                    color: "#F2721E",
                                                                    textDecoration: "none",
                                                                    fontSize: "16px",
                                                                }}
                                                                href="/register"
                                                            >
                                                                Đăng ký ngay!
                                                            </a>
                                                        </span>
                                                        <span style={{ color: "gray", fontSize: "16px" }}>
                                                            <a
                                                                style={{
                                                                    color: "#F2721E",
                                                                    textDecoration: "none",
                                                                    fontSize: "16px",
                                                                }}
                                                                href="/forgotpassword"
                                                            >
                                                                Quên Mật Khẩu!
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div >
            </div >      </motion.div>
    );
}

export default Login;
